// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__aEuhm","summary":"CartItem_summary__+lN4J","price":"CartItem_price__pvYpy","amount":"CartItem_amount__pe2hr","actions":"CartItem_actions__FKKlT"};